import React, { useEffect, useState } from "react";
import SwiperProduct from "./SwiperProduct";
import ShopNow from "../ui/ShopNow";
import OptionsProduct from "./OptionsProduct";
import { optionsProductData } from "../../data";
import { v4 } from "uuid";
import { axiosClient } from "../../utils/axios";
const Products = () => {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const fetchNewestProducts = async () => {
      try {
        setIsLoading(true);
        const res = await axiosClient.get("api/products/newest");
        setProducts(res.data.products);
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchNewestProducts();
  }, []);
  return (
    <div className="container mx-auto sm:p-4 lg:px-[160px] sm:pl-8">
      <div className="mb-10 px-8 py-6 rounded-3xl shadow-lg border">
        {/* Slider Products */}
        <div className="flex items-center mb-4 gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 1080 1080"
            fill="none"
          >
            <path
              d="M515.09 725.824L472.006 824.503C455.444 862.434 402.954 862.434 386.393 824.503L343.308 725.824C304.966 638.006 235.953 568.104 149.868 529.892L31.2779 477.251C-6.42601 460.515 -6.42594 405.665 31.2779 388.929L146.164 337.932C234.463 298.737 304.714 226.244 342.401 135.431L386.044 30.2693C402.239 -8.75637 456.159 -8.75646 472.355 30.2692L515.998 135.432C553.685 226.244 623.935 298.737 712.234 337.932L827.121 388.929C864.825 405.665 864.825 460.515 827.121 477.251L708.53 529.892C622.446 568.104 553.433 638.006 515.09 725.824Z"
              fill="url(#paint0_radial_2525_777)"
            ></path>{" "}
            <path
              d="M915.485 1036.98L903.367 1064.75C894.499 1085.08 866.349 1085.08 857.481 1064.75L845.364 1036.98C823.765 987.465 784.862 948.042 736.318 926.475L698.987 909.889C678.802 900.921 678.802 871.578 698.987 862.61L734.231 846.951C784.023 824.829 823.623 783.947 844.851 732.75L857.294 702.741C865.966 681.826 894.882 681.826 903.554 702.741L915.997 732.75C937.225 783.947 976.826 824.829 1026.62 846.951L1061.86 862.61C1082.05 871.578 1082.05 900.921 1061.86 909.889L1024.53 926.475C975.987 948.042 937.083 987.465 915.485 1036.98Z"
              fill="url(#paint1_radial_2525_777)"
            ></path>{" "}
            <defs>
              <radialGradient
                id="paint0_radial_2525_777"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(670.447 474.006) rotate(78.858) scale(665.5 665.824)"
              >
                <stop stop-color="#1BA1E3"></stop>{" "}
                <stop offset="0.0001" stop-color="#1BA1E3"></stop>{" "}
                <stop offset="0.300221" stop-color="#5489D6"></stop>{" "}
                <stop offset="0.545524" stop-color="#9B72CB"></stop>{" "}
                <stop offset="0.825372" stop-color="#D96570"></stop>{" "}
                <stop offset="1" stop-color="#F49C46"></stop>
              </radialGradient>{" "}
              <radialGradient
                id="paint1_radial_2525_777"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(670.447 474.006) rotate(78.858) scale(665.5 665.824)"
              >
                <stop stop-color="#1BA1E3"></stop>{" "}
                <stop offset="0.0001" stop-color="#1BA1E3"></stop>{" "}
                <stop offset="0.300221" stop-color="#5489D6"></stop>{" "}
                <stop offset="0.545524" stop-color="#9B72CB"></stop>{" "}
                <stop offset="0.825372" stop-color="#D96570"></stop>{" "}
                <stop offset="1" stop-color="#F49C46"></stop>
              </radialGradient>
            </defs>
          </svg>
          <h3 className="text-3xl text-[#04297A] font-medium leading-10 font-inter ">
            Suggestion
          </h3>
        </div>

        <SwiperProduct products={products.slice(0, 10)} isLoading={isLoading} />
      </div>
      <div className="">
        <ShopNow title="More Products" />
        <div className="grid grid-cols-2 gap-x-2 gap-y-6 py-8 md:grid-cols-4 md:gap-x-6">
          {optionsProductData.map((item) => (
            <React.Fragment key={v4()}>
              <OptionsProduct
                title={item.title}
                desc={item.desc}
                icon={item.icon}
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products;
